import { State } from 'jumpstate'
import { addTimestamps } from 'webmango-core/utils'

export default function SyncState (prefix, api = {}) {
  return State(prefix, {
    initial: {},
    put (state = {}, payload) {
      const { id } = payload
      if (payload.deleted || payload._deleted) {
        if (!state[id]) return state
        const nextState = { ...state }
        delete nextState[id]
        return nextState
      }
      return {
        ...state,
        [id]: addTimestamps(state[id], Object.assign({}, payload, {
          _revisions: undefined
        }))
      }
    },
    remove (state = {}, payload) {
      const id = payload.id || payload._id || payload
      if (!state[id]) return state // ignore if item not exists
      const nextState = { ...state }
      delete nextState[id]
      return nextState
    },
    initialise (state = {}, payload) {
      const nextState = { ...state }
      let changes = 0
      payload.forEach((data = {}) => {
        const id = data.id || data._id
        if (!id) return
        if (data.deleted || data._deleted) {
          if (!state[id]) return // ignore deleted items not in state
          // remove deleted items
          delete nextState[id]
        } else {
          // update/add item
          nextState[id] = addTimestamps({}, Object.assign({}, data, {
            id,
            _revisions: undefined
          }))
        }
        changes++
      })
      if (!changes) return state // if no changes return same state
      return nextState
    },
    ...api
  })
}



// WEBPACK FOOTER //
// ../webmango-core/state/lib/SyncState.js